// Core
import React, { FC, ReactElement, useRef } from 'react';
import Transition, { TransitionStatus } from 'react-transition-group/Transition';
import { AlwLadderItem, AlwSupportedGamesIds } from '../../types';

// Styles
import Styles from './styles.module.scss';

// Instruments
import ReactTooltip from 'react-tooltip';
import { opacityTransitionConfig } from 'utils/transitionConfig';
import coin from 'theme/assets/svg/v5/alw-contest/coin.svg';
import cup from 'theme/assets/svg/v5/alw-contest/cup.svg';

type AlwTableRowProps = {
    className?: string;
    index: number;
    inProp: boolean;
    winner: boolean;

    ladderChosenGame: AlwSupportedGamesIds;
} & AlwLadderItem;

export const AlwTableRow: FC<AlwTableRowProps> = ({
    index,
    inProp,
    nickname,
    score,
    winner,
    reward,
    rank,
    ladderChosenGame,
}): ReactElement => {
    const nodeRef = useRef(null);

    return (
        <Transition
            in={inProp}
            appear
            mountOnEnter
            unmountOnExit
            timeout={opacityTransitionConfig().timeout}
            nodeRef={nodeRef}
        >
            {(state: TransitionStatus) => (
                <div
                    className={[Styles.container, winner && Styles.winner]
                        .filter(Boolean)
                        .join(' ')}
                    style={{
                        ...opacityTransitionConfig().defaultStyles,
                        ...opacityTransitionConfig().transitionStyles[state],
                        position: 'relative',
                        top: 0,
                        bottom: 0,
                        zIndex: 1,
                        transition: 'all 0.1s',
                    }}
                >
                    <img
                        src={winner ? cup : coin}
                        alt=''
                        className={winner ? Styles.winnerCup : Styles.coin}
                        data-for={!winner && +rank <= 1500 ? `alw-tooltip-${index}` : undefined}
                        data-tip={`Eligible for guaranteed reward of ${
                            [5426, 21640].includes(ladderChosenGame) ? '650RP' : '5$'
                        }`}
                        style={+rank >= 1500 ? { visibility: 'hidden' } : undefined}
                    />
                    <span>#{rank}</span>

                    <span className={Styles.username}>{nickname}</span>

                    <span className={Styles.prize}>
                        {winner
                            ? 'Alienware Gaming Rig!'
                            : reward?.weekSequence !== undefined
                            ? `Week ${reward.weekSequence + 1} Winner`
                            : ''}
                    </span>

                    <span className={Styles.points}>
                        {score}
                        {reward ? (
                            <img
                                src={cup}
                                alt=''
                                className={Styles.cup}
                                data-for={`alw-tooltip-cup-${index}`}
                                data-tip="Previous week's winners are not eligible for winning the main prize for the 2nd time."
                            />
                        ) : (
                            <div className={Styles.cup} />
                        )}
                    </span>

                    {/* tooltips onHover */}
                    <ReactTooltip
                        id={`alw-tooltip-${index}`}
                        data-event='hover'
                        place='top'
                        className={Styles.tooltip}
                        effect='solid'
                        backgroundColor='#00D2D7'
                        borderColor='#00D2D7'
                        textColor='#2A2829'
                        border
                    />
                    <ReactTooltip
                        id={`alw-tooltip-cup-${index}`}
                        data-event='hover'
                        place='left'
                        className={Styles.cupTooltip}
                        effect='solid'
                        backgroundColor='#00D2D7'
                        borderColor='#00D2D7'
                        textColor='#2A2829'
                        multiline
                        border
                    />
                </div>
            )}
        </Transition>
    );
};
